// TaskList.js - Task Categories with Collapsible Micro-tasks
import React from 'react';
import TaskCategory from './TaskCategory';

const tasks = [
    {
        title: 'Critical Deadlines 🚨',
        tasks: ['File Taxes by April 15', 'Grant submission due May 30'],
    },
    {
        title: 'Regular Maintenance 📅',
        tasks: ['Do dishes', 'Vacuum living room'],
    },
    {
        title: 'Micro Self-Care 🧘',
        tasks: ['Brush & floss teeth', 'Hair care routine', 'Vitamins & medication'],
        collapsible: true,
    },
];

const TaskList = () => (
    <div className="p-4">
        {tasks.map((category, idx) => (
            <TaskCategory
                key={idx}
                title={category.title}
                tasks={category.tasks}
                collapsible={category.collapsible}
            />
        ))}
    </div>
);

export default TaskList;
